type orderDetailsObj = {
    externalOrderId: string,
    orderPrimaryStatus: string,
    orderTrackingStatus: string,
    orderDateRaw: string,
    orderEstimatedDeliveryDate: string,
    courier: string,
    currentLocation: string,
}

export const trackOrderDetailsTracking = (orders: orderDetailsObj[], type: "order"|"return") => {
    const formattedOrders = orders.map((order) => buildOrderDetailTrackingObject(order))
    return {
        event: `${type} tracking module load`,
        category: {
            primaryCategory: 'ecommerce',
            subCategory: `${type} tracking`,
        },
        orders: formattedOrders,
    }
}

const buildOrderDetailTrackingObject = ({
    externalOrderId,
    orderPrimaryStatus,
    orderTrackingStatus,
    orderDateRaw,
    orderEstimatedDeliveryDate,
    courier,
    currentLocation,
}: orderDetailsObj) => { 
    const currentStatus = orderPrimaryStatus?.toLowerCase().replace(/_/g, ' ') || ''
    const currentSecondaryStatus = orderTrackingStatus?.toLowerCase().replace(/_/g, ' ') || ''

    return {
        id: externalOrderId,
        currentStatus,
        currentSecondaryStatus,
        placedDate: orderDateRaw,
        deliveryEstimateDate: formatDate(orderEstimatedDeliveryDate),
        courier,
        currentLocation,
    }
}

const formatDate = (date: string) => {
    if (!date) return ''
    const formattedDate = new Date(date)
    formattedDate.setUTCHours(0, 0, 0, 0)
    return formattedDate.toISOString()
}
